// extracted by mini-css-extract-plugin
export default {"wrapper":"TutorWebinarFooter_wrapper__laNrI"};